import React, { FC } from 'react'
import { FixedLayout } from 'components/Layout'
import { ForgetTemplate } from 'components/Templates'

const Forget: FC = () => {
  return (
    <FixedLayout title={'パスワードを変更する'}>
      <ForgetTemplate />
    </FixedLayout>
  )
}

export default Forget
